import React, { useEffect, useState } from "react";
import { getPrivacyPolicy } from "../api/api";

const TermsCondition = () => {
  const [policy, setPolicy] = useState("");

  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.terms_condition) {
        setPolicy(response.data.terms_condition);
      } else {
        setPolicy("<p>Failed to load terms and conditions.</p>");
      }
    };

    fetchPolicy();
  }, []);

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default TermsCondition;
